import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import EventsLayer from '../components/EventsLayer';

const EventsPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Events">
        <EventsLayer />
      </MasterLayout>
    </>
  );
};

export default EventsPage;
